const NOFX=new URLSearchParams(location.search).has('nofx')||matchMedia('(prefers-reduced-motion: reduce)').matches;
let tT;function soon(){const t=document.getElementById('toast');if(!t)return;t.style.transform='translateX(-50%) translateY(0)';clearTimeout(tT);tT=setTimeout(()=>t.style.transform='translateX(-50%) translateY(160%)',2400);}

/* KPI count-up — native IntersectionObserver, independent of GSAP/Lenis so it can never get stuck at 0.
   Always paints the final value first (fallback), then animates 0->end when scrolled into view. */
(function(){
  document.querySelectorAll('[data-count]').forEach(el=>{
    const end=+el.dataset.count, dec=+(el.dataset.dec||0);
    const set=v=>{ el.childNodes[0].nodeValue=v.toFixed(dec); };
    set(end);                       // never show 0
    if(NOFX) return;                // respect reduced-motion: keep final value, no animation
    const io=new IntersectionObserver(entries=>{
      entries.forEach(e=>{
        if(!e.isIntersecting) return;
        let t0=null; const dur=1500; set(0);
        const step=t=>{ if(t0===null)t0=t; const p=Math.min((t-t0)/dur,1);
          set(end*(1-Math.pow(1-p,3))); if(p<1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    },{threshold:0.35});
    io.observe(el);
  });
})();

if(!NOFX&&window.gsap){
  gsap.registerPlugin(ScrollTrigger);
  if(window.Lenis){const l=new Lenis({lerp:.09});l.on('scroll',ScrollTrigger.update);gsap.ticker.add(t=>l.raf(t*1000));gsap.ticker.lagSmoothing(0);}
  const tl=gsap.timeline({defaults:{ease:'power4.out'}});
  tl.from('[data-hero]',{yPercent:120,duration:1.15,stagger:.12})
    .from('.hero-copy [data-rise]',{y:26,opacity:0,duration:.85,stagger:.07},'-=.7')
    .from('.hero-stage',{opacity:0,x:50,duration:1.2,ease:'power3.out'},'-=1')
    .from('.hero-vid',{clipPath:'inset(0 0 100% 0)',duration:1.1,ease:'power3.out'},'-=1');
  gsap.utils.toArray('.sec [data-rise],.statement [data-rise],.editorial [data-rise],.cta [data-rise]').forEach(el=>{
    gsap.from(el,{y:36,opacity:0,duration:.9,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 88%'}});});
  gsap.from('[data-words]',{opacity:0,y:40,duration:1,ease:'power3.out',scrollTrigger:{trigger:'[data-words]',start:'top 78%'}});
  gsap.utils.toArray('[data-card]').forEach(el=>{gsap.from(el,{y:44,opacity:0,duration:.9,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 90%'}});});
  gsap.from('[data-feat]',{opacity:0,y:18,duration:.7,stagger:.15,ease:'power3.out',scrollTrigger:{trigger:'.ana-stage,.feats',start:'top 66%'}});
  gsap.from('.feat .lead',{scaleX:0,duration:.7,stagger:.15,ease:'power3.out',scrollTrigger:{trigger:'.ana-hold',start:'top 60%'}});
  gsap.to('#strip',{xPercent:-50,duration:26,ease:'none',repeat:-1});
  gsap.fromTo('#ediImg',{scale:1.14,y:'-4%'},{scale:1.02,y:'4%',ease:'none',scrollTrigger:{trigger:'.editorial',start:'top bottom',end:'bottom top',scrub:true}});
  const stage=document.querySelector('[data-tilt]');
  if(stage){stage.addEventListener('mousemove',e=>{const r=stage.getBoundingClientRect();const rx=(e.clientY-r.top-r.height/2)/r.height*-5;const ry=(e.clientX-r.left-r.width/2)/r.width*7;gsap.to(stage,{rotateX:rx,rotateY:ry,transformPerspective:1000,duration:.5});});
  stage.addEventListener('mouseleave',()=>gsap.to(stage,{rotateX:0,rotateY:0,duration:.6,ease:'power2.out'}));}
  gsap.utils.toArray('.magnetic').forEach(el=>{
    el.addEventListener('mousemove',e=>{const r=el.getBoundingClientRect();gsap.to(el,{x:(e.clientX-r.left-r.width/2)*.3,y:(e.clientY-r.top-r.height/2)*.4,duration:.4});});
    el.addEventListener('mouseleave',()=>gsap.to(el,{x:0,y:0,duration:.5,ease:'elastic.out(1,.4)'}));});
  /* recompute trigger positions after fonts/video/images change layout height (prevents stuck triggers) */
  addEventListener('load',()=>ScrollTrigger.refresh());
  const hv=document.querySelector('video');
  if(hv)hv.addEventListener('loadeddata',()=>ScrollTrigger.refresh());
  /* failsafe: if any reveal element is still hidden 4s in (trigger never fired), force-show it */
  setTimeout(()=>{document.querySelectorAll('[data-rise],[data-card],[data-feat]').forEach(el=>{
    if(getComputedStyle(el).opacity==='0'){el.style.opacity='1';el.style.transform='none';}});},4000);
}
